import { of as observableOf, Observable } from "rxjs";

import { catchError, map, switchMap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { KpiService } from "../../kpi/kpi.service";
import {
  GET_DISTRICT,
  GET_DISTRICT_SUCCESS,
  GET_DISTRICT_ERROR,
} from "./actions";

@Injectable()
export class DistrictEffects {
  constructor(private actions$: Actions, private kpiService: KpiService) {}

  @Effect() getDistrict = this.actions$.pipe(
    ofType(GET_DISTRICT),
    switchMap((action) =>
      this.kpiService.getDistrict().pipe(
        map((district) => ({
          type: GET_DISTRICT_SUCCESS,
          payload: district,
        })),
        catchError(() => observableOf({ type: GET_DISTRICT_ERROR }))
      )
    )
  );
}
